import React from 'react';

const SubscriptionCalloutBanner: React.FC = () => {
    return (
        <div className='mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg'>
            <div className='flex items-start'>
                <svg
                    className='w-5 h-5 text-blue-600 mr-3 mt-0.5 flex-shrink-0'
                    fill='none'
                    stroke='currentColor'
                    viewBox='0 0 24 24'
                >
                    <path
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        strokeWidth='2'
                        d='M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
                    />
                </svg>
                <div>
                    <p className='text-sm font-medium text-blue-900 mb-1'>Subscription Details</p>
                    <p className='text-sm text-blue-700'>
                        First payment: $5.00 today, then $5.00 monthly until you cancel
                    </p>
                </div>
            </div>
        </div>
    );
};

export default SubscriptionCalloutBanner;
